import React, { useState } from 'react';
import Layout from '../../components/Layout';
import {
    Alert,
    Button,
    Col,
    Container,
    Form,
    Row,
} from 'react-bootstrap';
import Input from '../../components/UI/Input';
import { login } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import AlertComponent from '../../components/Alert/Alert';
import { setCloseAlertAuth } from '../../reducers/auth.reducers';
import {
    SESSION_EXPIRED_MESSAGE,
    SESSION_EXPIRED_REASON,
    consumeSessionExpiredNotice,
} from '../../helpers/authSession';

const Signin = () => {
    const {
        authenticating,
        authenticate,
        variantAlert,
        showAlert,
        message,
    } = useSelector((state) => state.auth);

    const location = useLocation();
    const dispatch = useDispatch();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [sessionExpiredMessage] = useState(() => {
        const storedMessage = consumeSessionExpiredNotice();
        const reason = new URLSearchParams(location.search).get('reason');

        if (storedMessage) return storedMessage;
        if (reason === SESSION_EXPIRED_REASON) return SESSION_EXPIRED_MESSAGE;

        return '';
    });

    const userLogin = (event) => {
        event.preventDefault();

        dispatch(login({
            email,
            password,
        }));
    };

    if (authenticate) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Layout>
                <Container>
                    <Row style={{ marginTop: '100px' }}>
                        <Col md={{ span: 6, offset: 3 }}>
                            {sessionExpiredMessage ? (
                                <Alert variant="warning">
                                    <Alert.Heading>Сессия завершена</Alert.Heading>
                                    <p style={{ marginBottom: 0 }}>
                                        {sessionExpiredMessage}
                                    </p>
                                </Alert>
                            ) : null}

                            <Form onSubmit={userLogin}>
                                <Input
                                    label="Email"
                                    placeholder="Введите email"
                                    value={email}
                                    type="email"
                                    onChange={(event) => setEmail(event.target.value)}
                                />

                                <Input
                                    label="Пароль"
                                    placeholder="Введите пароль"
                                    value={password}
                                    type="password"
                                    onChange={(event) => setPassword(event.target.value)}
                                />

                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={authenticating}
                                >
                                    {authenticating ? 'Входим...' : 'Войти'}
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Layout>

            <AlertComponent
                dispatchCloseAlert={() => dispatch(setCloseAlertAuth())}
                color={variantAlert}
                showObj={showAlert && !sessionExpiredMessage}
                text={message}
            />
        </>
    );
};

export default Signin;
